import { ApolloError, gql, useMutation } from "@apollo/client";
import {
  EditOrdersStatusWithQuantityMutation,
  EditOrdersStatusWithQuantityMutationVariables,
} from "../generated/graphql";

const EDIT_ORDERS_STATUS_WITH_QUANTITY_MUTATION = gql`
  mutation editOrdersStatusWithQuantity(
    $input: EditOrdersStatusWithQuantityInput!
  ) {
    editOrdersStatusWithQuantity(input: $input) {
      ok
      err
    }
  }
`;

export const useEditOrdersStatusWithQuantity = (
  onCompleted?: (data: EditOrdersStatusWithQuantityMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<
    EditOrdersStatusWithQuantityMutation,
    EditOrdersStatusWithQuantityMutationVariables
  >(EDIT_ORDERS_STATUS_WITH_QUANTITY_MUTATION, {
    onCompleted,
    onError,
  });
};
